import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-728df7b7")

_pushScopeId("data-v-728df7b7")
const _hoisted_1 = { class: "users-button" }
const _hoisted_2 = { class: "content-wrap" }
const _hoisted_3 = { class: "contact-wrap" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TitleOption = _resolveComponent("TitleOption")
  const _component_ContactItem = _resolveComponent("ContactItem")
  const _component_PopUpWithButton = _resolveComponent("PopUpWithButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_PopUpWithButton, {
      class: "users",
      name: "ic25-users",
      size: "25px"
    }, {
      content: _withId(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_TitleOption, {
            class: "title-option",
            title: "users"
          }),
          _createVNode("div", _hoisted_3, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.chatStore.users, (item) => {
              return (_openBlock(), _createBlock(_component_ContactItem, {
                item: item.user.displayName,
                image: item.auth.avatar
              }, null, 8, ["item", "image"]))
            }), 256))
          ])
        ])
      ]),
      _: 1
    })
  ]))
})